import React from "react";
import timer from "../../assets/svg/reportspage/gif/timerGIf.gif";
import { useSelector } from "react-redux";
import { getUserInfo } from "../../store/auth/selectors";
import useLeadCapture from "../../pages/UseLeadCapture";
import lock from "../../assets/svg/reportspage/lock.svg";
import paidTick from "../../assets/svg/reportspage/paidTick.svg";
import olympaidblur from "../../assets/svg/reportspage/olympaidblur.jpg";
import emsatblur from "../../assets/svg/reportspage/emsatblur.jpg";
import scoreblur from "../../assets/svg/reportspage/scoreblur.jpg";
import Testimonials from "./Testimonials";
import tick from "../../assets/svg/reportspage/gif/tick.gif";

export const Timer = ({ condition, timeLeft, examType, onOpenTalkToExpert }) => {
  const userInfo = useSelector(getUserInfo);
  const { handelAlerbarLead } = useLeadCapture();

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const m = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${h}h:${m}m:${s}s`;
  };

  const blur = (examType) => {
    if (examType?.includes("score")) {
      return scoreblur;
    } else if (examType?.includes("olympiad")) {
      return olympaidblur;
    } else if (examType?.includes("emsat")) {
      return emsatblur;
    } else {
      return scoreblur;
    }
  };

  const handleBookDemoClick = () => {
    const params = {
      source: "book_demo"
    };
    handelAlerbarLead(params);

    if (onOpenTalkToExpert) {
      onOpenTalkToExpert("book_demo");
    }
  };

  return (
    <div>
      {condition === "timer" && (
        <div
          className="Rep_bluredreport-cont"
          style={{
            backgroundImage: `url(${blur(examType)})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        >
          <img className="Rep_paidTick" src={lock} alt="lock" />
          <h4>Unlock your Detailed Report</h4>
          <p className="Rep_timer-timecont">Book a free demo with our experts and get full access instantly</p>

          <button onClick={handleBookDemoClick} className="attempt-btn" style={{ marginTop: "1rem" }}>
            Book a Demo
          </button>

          <div style={{ width: "100%" }}>
            <Testimonials />
          </div>
        </div>
      )}

      {condition === "almost" && (
        <div
          className="Rep_bluredreport-cont"
          style={{
            backgroundImage: `url(${blur(examType)})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        >
          <img className="Rep_paidTick" src={paidTick} alt="lock" />
          <h4>Demo Booking is Successful</h4>
          <p className="Rep_timer-timecont">
            We are generating a detailed report for you.
            <br /> it will be available shortly
            <br />
            <span className="Rep_Paidtimer-time">{formatTime(timeLeft)}</span>
          </p>
          <img className="Rep_sandtimer" src={timer} alt="timer" />
          <div style={{ width: "100%" }}>
            <Testimonials />
          </div>
        </div>
      )}

      {condition === "Notyet" && (
        <div
          className="Rep_bluredreport-cont"
          style={{
            backgroundImage: `url(${blur(examType)})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        >
          <img className="Rep_paidTick" src={paidTick} alt="lock" />
          <h4>Demo Booking is Successful</h4>
          <h1>Uh-uh!</h1>
          <p className="Rep_timer-des">
            Your demo booking was successful, but there's a slight delay in generating your report. It will be ready
            soon!
          </p>
          <p className="Rep_timer-des">
            If you don't see it in a few minutes, please call our support team at +91 87927 40465. We're here to help!
          </p>
          <img className="Rep_sandtimer" src={timer} alt="timer" />
          <p className="Rep_timer-des">Thank you for your patience!</p>

          <div style={{ width: "100%" }}>
            <Testimonials />
          </div>
        </div>
      )}

      {condition === "NoPymmenttimer" && (
        <div className="Rep_timer-cont">
          <h1>But Wait!</h1>
          <p className="Rep_timer-des">
            We are generating a detailed report for you.
            <br />
            <span>You can check back in</span>
          </p>
          <p className="Rep_timer-time">{formatTime(timeLeft)}</p>
          <img src={timer} alt="Timer" />
        </div>
      )}

      {condition === "NoPymmentalmost" && (
        <div className="Rep_timer-cont">
          <h1>Uh-uh!</h1>
          <p className="Rep_timer-des">
            Rest assured, your report is in the queue.
            <br />
            We will update you once it's ready
          </p>
          <img src={timer} alt="Timer" />
        </div>
      )}

      {condition === "NoPymmentready" && (
        <div className="Rep_timer-cont">
          <h1>Your detailed report is ready!</h1>
          <img src={tick} alt="Tick" />
          <button className="attempt-btn">View Detailed Report</button>
        </div>
      )}
    </div>
  );
};
